export default __webpack_public_path__ + "static/media/WeatherApp.36a774d1.jpg";